export const OPENPAY_ERROR_MESSAGES: Record<number, string> = {
    // Generales
    1000: "Ocurrió un error interno. Por favor, intenta nuevamente.",
    1001: "La información enviada no es válida.",
    1002: "No fue posible autenticar la solicitud.",
    1003: "Uno o más datos proporcionados no son correctos.",
    1004: "El servicio de pagos no está disponible en este momento.",
    1005: "El recurso solicitado no existe.",
    1006: "La operación ya existe y no puede procesarse nuevamente.",
    1007: "La transferencia de fondos no fue aceptada.",
    1008: "La cuenta requerida se encuentra desactivada.",
    1009: "La solicitud es demasiado grande.",
    1010: "La operación no está autorizada.",

    // Almacenamiento
    2001: "La cuenta bancaria ya se encuentra registrada.",
    2002: "La tarjeta ya se encuentra registrada.",
    2003: "El cliente ya se encuentra registrado.",
    2004: "El número de tarjeta no es válido.",
    2005: "La fecha de expiración de la tarjeta no es válida.",
    2006: "El código de seguridad de la tarjeta es requerido.",
    2007: "Esta tarjeta de prueba solo puede utilizarse en Sandbox.",
    2008: "La tarjeta no es válida para esta operación.",
    2009: "El código de seguridad de la tarjeta no es válido.",

    // Tarjetas
    3001: "La tarjeta fue declinada.",
    3002: "La tarjeta ha expirado.",
    3003: "La tarjeta no tiene fondos suficientes.",
    3004: "La tarjeta fue identificada como robada.",
    3005: "La tarjeta fue identificada como fraudulenta.",
    3006: "La operación no está permitida para esta tarjeta.",
    3008: "La tarjeta no es compatible con transacciones en línea.",
    3009: "La tarjeta fue reportada como perdida.",
    3010: "El banco ha restringido la tarjeta.",
    3011: "El banco ha solicitado que la tarjeta sea retenida.",
    3012: "Es necesario solicitar autorización al banco para realizar este pago.",

    // Cuentas
    4001: "La cuenta de Openpay no tiene fondos suficientes.",
};



export const OPENPAY_MESSAGES: Record<number, string> = {
    // Generales
    1000: "Ocurrió un error interno. Por favor, intenta nuevamente.",
    1001: "La información enviada no es válida.",
    1002: "No fue posible autenticar la solicitud.",
    1003: "Uno o más datos proporcionados no son correctos.",
    1004: "El servicio de pagos no está disponible en este momento.",
    1005: "El recurso solicitado no existe.",
    1006: "La operación ya existe y no puede procesarse nuevamente.",
    1007: "La transferencia de fondos no fue aceptada.",
    1008: "La cuenta requerida se encuentra desactivada.",
    1009: "La solicitud es demasiado grande.",
    1010: "La operación no está autorizada.",

    // Almacenamiento
    2001: "La cuenta bancaria ya se encuentra registrada.",
    2002: "La tarjeta ya se encuentra registrada.",
    2003: "El cliente ya se encuentra registrado.",
    2004: "El número de tarjeta no es válido.",
    2005: "La fecha de expiración de la tarjeta no es válida.",
    2006: "El código de seguridad de la tarjeta es requerido.",
    2007: "Esta tarjeta de prueba solo puede utilizarse en Sandbox.",
    2008: "La tarjeta no es válida para esta operación.",
    2009: "El código de seguridad de la tarjeta no es válido.",

    // Tarjetas
    3001: "La tarjeta fue declinada.",
    3002: "La tarjeta ha expirado.",
    3003: "La tarjeta no tiene fondos suficientes.",
    3004: "La tarjeta fue identificada como robada.",
    3005: "La tarjeta fue identificada como fraudulenta.",
    3006: "La operación no está permitida para esta tarjeta.",
    3008: "La tarjeta no es compatible con transacciones en línea.",
    3009: "La tarjeta fue reportada como perdida.",
    3010: "El banco ha restringido la tarjeta.",
    3011: "El banco ha solicitado que la tarjeta sea retenida.",
    3012: "Es necesario solicitar autorización al banco para realizar este pago.",

    // Cuentas
    4001: "La cuenta de Openpay no tiene fondos suficientes.",
};

export const OPENPAY_ERRORS = {
    "La transacción ha sido declinada": "Tarjeta rechazada por el banco (Numero de validación incorrecto)",
    "La tarjeta ha expirado": "La tarjeta ha expirado",
    "La tarjeta no tiene fondos suficientes":
        "La tarjeta no tiene fondos suficientes",
    "La tarjeta fue identificada como robada":
        "La tarjeta fue identificada como robada",
    "La tarjeta fue identificada como fraudulenta":
        "La tarjeta fue identificada como fraudulenta",
    "La operación no está permitida para esta tarjeta":
        "La operación no está permitida para esta tarjeta",
    "La tarjeta no es compatible con transacciones en línea":
        "La tarjeta no es compatible con transacciones en línea",
    "La tarjeta fue reportada como perdida":
        "La tarjeta fue reportada como perdida",
    'failed': "El banco ha restringido la tarjeta",
    "El banco ha solicitado que la tarjeta sea retenida":
        "El banco ha solicitado que la tarjeta sea retenida",
    "Es necesario solicitar autorización al banco para realizar este pago":
        "Es necesario solicitar autorización al banco para realizar este pago",
} as const;

export const getOpenpayErrorMessage = (errorCode: string): string => {
    return (
        OPENPAY_ERRORS[errorCode as keyof typeof OPENPAY_ERRORS] ??
       errorCode
    );
};